import React from 'react'

interface CompProps {
  width: any
  height: any
}
const TourIcon: React.FC<CompProps> = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox={'0 0 29 30'}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M28.0959 13.013L16.6847 1.60094C15.5867 0.503382 13.8072 0.503382 12.7095 1.60094L1.29832 13.013C0.200691 14.1107 0.200691 15.8896 1.29832 16.9873L12.7098 28.3992C13.2588 28.9479 13.978 29.2222 14.6971 29.2222C15.4163 29.2222 16.1354 28.9479 16.6847 28.3992L28.0959 16.9871C29.1935 15.8896 29.1935 14.1104 28.0959 13.013ZM13.6038 10.8745L13.5198 11.6661C13.5142 11.7182 13.4903 11.7687 13.4524 11.8085L11.4045 13.9571C12.7543 14.2368 13.4949 15.1692 13.3578 16.4605C13.2679 17.3055 12.8915 18.0292 12.2685 18.5527C11.6515 19.0714 10.8479 19.3459 9.94421 19.3459C9.10912 19.3459 8.22554 19.0722 7.58087 18.6146L7.21789 18.3567C7.1708 18.3231 7.14197 18.2702 7.13786 18.2104C7.13391 18.1506 7.15509 18.0892 7.19672 18.0408L7.94829 17.1635C8.02887 17.0696 8.16256 17.0474 8.2528 17.1128L8.57509 17.3466C8.97212 17.6348 9.55934 17.8138 10.1072 17.8138C11.0932 17.8138 11.734 17.3237 11.8213 16.5027C11.8716 16.0302 11.7729 15.4023 10.3424 15.4023H9.16396C9.04236 15.4023 8.95434 15.3036 8.96723 15.1822L9.05129 14.39C9.0569 14.3381 9.08076 14.2873 9.11892 14.2475L11.0903 12.1864H8.48303C8.36143 12.1864 8.27334 12.0878 8.28629 11.9662L8.40229 10.8748C8.41532 10.7532 8.52436 10.6547 8.64588 10.6547H13.4069C13.5286 10.6544 13.6168 10.7529 13.6038 10.8745ZM17.3358 19.3457C19.7811 19.3457 21.9779 17.3986 22.2323 15.0052C22.4876 12.6062 20.7054 10.6544 18.2599 10.6544H14.9198C14.7984 10.6544 14.6891 10.7529 14.6762 10.8745L13.7988 19.1256C13.7859 19.2469 13.8739 19.3457 13.9957 19.3457H17.3358Z'
      fill='#1270B8'
    />
    <path
      d='M18.0958 12.1864H16.0676L15.4691 17.814H17.4973C19.0982 17.814 20.5343 16.554 20.699 15.0057C20.8646 13.451 19.6966 12.1864 18.0958 12.1864Z'
      fill='#1270B8'
    />
  </svg>
)

export default TourIcon
